export function post(url, data, isJSON = false, CSRF = false, trpcHeaders) {
    return $.ajax({
        url,
        type: 'POST',
        data: JSON.stringify(data || {}),
        dataType: 'json',
        xhrFields: {
            withCredentials: true,
        },
        CSRF,
        timeout: 5000,
        contentType: isJSON ? 'application/json' : 'text/plain;charset=UTF-8',
        headers: trpcHeaders || {},
    });
}
export function jsonp(url, query, trpcHeaders) {
    return $.ajax({
        url,
        type: 'GET',
        data: query || {},
        dataType: 'jsonp',
        timeout: 5000,
        CSRF: true,
        headers: trpcHeaders || {},
    });
}
